/**
 * The ID of the Flux bot.
 */
export const FLUX_BOT_ID = '00000000-0000-0000-0000-000000000000';

export const FLUX_HOSTNAMES = {
  NORMAL: 'app.fluxcontrol.com.br',
  HOMOLOG: 'app.fluxcontroldev.com',
  DEVELOPMENT: 'localhost:4200',
  BRADESCO: 'bradesco.fluxcontrol.com.br',
} as const;

/**
 * The issuer for the JWT token.
 */
export const ISSUER = {
  production: 'https://isengard.fluxcontrol.com.br',
  homolog: 'https://isengard.fluxcontroldev.com',
  development: 'http://localhost:4012',
} as const;

/**
 * The audience any token is rated for
 */
export const TOKEN_AUD = {
  CLIENT: 'aud:client',
  API: 'aud:api',
  SYNC_AUTOMATIONS: 'aud:sync-automations',
  AUTOMATIONS: 'aud:automations',
  REALTIME: 'aud:realtime',
  SERVER_TO_SERVER: 'aud:server-to-server',
} as const;

export * from '../domain/realtime/constants.js';

export * from '../domain/audit-log/constants.js';
